<template>
  <div class="header-box">
    <el-row type="flex" justify="space-between" style="padding-top:0.5vh">
      <el-col :span="15">
        <button class="btn-tool" title="折叠" @click="collapse">
          <i v-if="switchCollapses" style="color: #fafafa" class="el-icon-s-fold"></i>
          <i v-if="!switchCollapses" style="color: #fafafa" class="el-icon-s-unfold"></i>
        </button>
        <button class="btn-tool" style="color: whitesmoke;margin-left:10px;font-size: 20px" @click="consoles">
          <i class="el-icon-s-home"></i>
        </button>
        <span style="color: whitesmoke;margin-left:10px;flex-grow: 1;font-size: 18px">
          橙子维管平台&nbsp;&nbsp;渠道数据中心
        </span>
      </el-col>
      <el-header style="text-align: right; font-size: 12px">
        <el-dropdown>
          <div v-if="isQrCodeLogin == null" style="cursor:pointer;color:white;margin-right: 10px">
            {{ username }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <div v-else style="cursor:pointer;color:white;margin-right: 10px">
            欢迎 {{ username }} 当前查询权限：
            <span v-if="dashboardSales==0">暂无查询权限</span>
            <span v-if="dashboardSales==1">{{ supplierId }}</span>
            <span v-if="dashboardSales==2">您的对接导购</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="consoles">首页</el-dropdown-item>
            <el-dropdown-item @click.native="getAccountInfo" :disabled="dashboardSales == 0 || dashboardSales == 2">
              账户设置
            </el-dropdown-item>
            <el-dropdown-item @click.native="CoreAdmin"
                              :disabled="!(dashboardSales != 0 && dashboardSales != 2 && isAdmin == 1)">全局管理设置
            </el-dropdown-item>
            <el-dropdown-item @click.native="sss">登出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-header>
    </el-row>

    <el-dialog
      title="账户设置"
      v-if="centerDialogVisible"
      :visible.sync="centerDialogVisible"
      width="45%"
      center
      style="margin-top: -100px">
      <span>
        <el-form v-loading="loading" label-width="90px" style="text-align:left;width:70%;margin:0px auto" :rules="rules"
                 :model="password"
                 ref="password" class="myForm1">
          <el-form-item label="账户名称" :required=true>
            <el-input type="text" v-model="accountInfo.accountName" :disabled="true"></el-input>
          </el-form-item>
            <el-form-item label="密码修改" prop="oldPassword">
              <el-input v-model="password.oldPassword" placeholder="请输入原密码" show-password>
              </el-input>
            </el-form-item>

          <el-form-item prop="newPassword">
              <el-input v-model="password.newPassword" placeholder="请输入新密码" show-password>
              </el-input>
          </el-form-item>

          <el-form-item prop="checkPassword">
              <el-input type="password" v-model="password.checkPassword" placeholder="请重复输入新密码"></el-input>
          </el-form-item>
            <el-form-item :label="'业务员\n注册码'" :required=true>
              <el-input type="text" v-model="accountInfo.registrationCode"></el-input>
              <el-alert
                description="通路管理助手注册时需要输入业务员注册码才能进行注册使用,通过注册码注册的业务员账户将接受其所有者的管理"
                type="info"
                :closable="false"/>
            </el-form-item>

            <el-form-item :label="'核心管理员\n权限转让'">
              <el-select
                :disabled="disChangeAuthority"
                style="width: 100%"
                v-model="accountInfo.changeAuthority"
                popper-class="el-select"
                placeholder="选择被转让账户"
                value-key="id"
                clearable
              >
                <el-option v-for="item in changeAuthoritys" :value="item.id" :label="item.id"></el-option>
              </el-select>
              <el-alert
                description="转让后双方账户会强制登出,并推送转让消息至双方微信"
                type="info"
                :closable="false"
              />
            </el-form-item>
        </el-form>
        <el-form v-loading="loading" label-width="90px" style="text-align:left;width:70%;margin:0px auto" :rules="rules"
                 :model="accountInfo"
                 class="myForm"
                 ref="ruleForm">
          <el-form-item :label="'账号管理员'">
              <el-select
                clearable
                multiple
                style="width: 100%"
                v-model="accountInfo.isManager"
                popper-class="el-select"
                placeholder="选择被转让账户"
                value-key="name"
              >
                <el-option v-for="item in accountInfo.managerInfo" :key="item" :value="item"
                           :label="item.name"></el-option>
              </el-select>
              <el-alert
                description="转让后双方账户会强制登出,并推送转让消息至双方微信"
                type="info"
                :closable="false"
              />
            </el-form-item>
          </el-form>
        </span>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="setAccountInfo">确认修改</el-button>
          <el-button @click="quxiao">取消修改</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import {setAccountInfo, getAccountInfo} from '@/api/CoreAdmin'

export default {
  inject: ['reload'],
  data() {
    let validateOldPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入密码"))
      } else {
        callback()
      }
    };
    let validateNewPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入新密码"))
      } else if (value === this.password.oldPassword) {
        callback(new Error('新密码不能与原密码相同!'))
      } else {
        callback()
      }
    };
    //此处即表单发送之前验证  验证新密码与再次确认
    let validateNewPassword2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error("请输入再次密码"))
      } else if (this.password.oldPassword === this.password.newPassword) {
        callback(new Error('新密码不能与原密码相同!'))
      } else if (value !== this.password.newPassword) {
        callback(new Error('与新密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      token: '',
      loading: false,
      dashboardSales: '',
      supplierId: '',
      isCollapse: false,
      dialogVisible: false,
      switchCollapses: true,
      centerDialogVisible: false,
      data: {},
      accountInfo: {
        supplierId: '',
        accountName: '',
        registrationCode: '',
        changeAuthority: '',
        newPassword: '',
        oldPassword: '',
        isManager: [],
        managerInfo: []
      },
      disChangeAuthority: true,
      changeAuthoritys: [],
      password: {
        oldPassword: '',
        newPassword: '',
        checkPassword: ''
      },
      isAdmin: '',
      isQrCodeLogin: '',
      registrationCode: '',
      rules: {
        //验证规则
        oldPassword: [{required: false, validator: validateOldPassword, trigger: 'blur'}],
        newPassword: [{required: true, validator: validateNewPassword, trigger: 'blur'}],
        checkPassword: [{required: true, validator: validateNewPassword2, trigger: 'blur'}],
      }
    };
  },
  created() {
    this.isQrCodeLogin = localStorage.getItem('userSupplierId')
    this.supplierId = localStorage.getItem('supplierId')
    this.dashboardSales = localStorage.getItem('dashboardSales')
    this.isAdmin = localStorage.getItem('isAdmin')
    this.token = localStorage.getItem('token')
  },
  methods: {
    consoles() {
      this.$router.replace({path: '/console'})
      history.go(0)
    },
    CoreAdmin() {
      this.$router.replace({path: '/CoreAdmin'})
      history.go(0)
    },
    collapse() {
      if (this.switchCollapses) {
        this.switchCollapses = false
      } else {
        this.switchCollapses = true
      }
      this.$store.commit('switchCollapse')
    },
    sss() {
      this.$router.replace({path: '/login'})
    },
    getAccountInfo() {
      this.accountInfo.isManager = []

      this.centerDialogVisible = true
      getAccountInfo(this.token).then(res => {
        this.password = {
          oldPassword: '',
          newPassword: '',
          checkPassword: ''
        }

        if (res.data != null) {
          let {data} = res
          this.accountInfo.supplierId = data.supplierId;
          this.accountInfo.accountName = data.accountName;
          this.accountInfo.registrationCode = data.registrationCode;
          this.registrationCode = data.registrationCode;
          this.accountInfo.managerInfo = data.managerInfo;
          this.changeAuthoritys = data.changeAuthoritys;

          this.accountInfo.isManager = [...this.accountInfo.isManager, ...data.managerInfo.filter(item => item.dashboard_sales == 1)];

          this.changeAuthoritys.forEach(item => {
            if (item.is_admin == 1 && this.accountInfo.accountName == item.id) {
              this.accountInfo.changeAuthority = item.id;
              this.disChangeAuthority = false;
            } else if (this.accountInfo.changeAuthority == '' && item.is_admin == 1) {
              this.accountInfo.changeAuthority = item.id;
            }
          })
        }
      })
    },
    setAccountInfo() {
      let checkPasswd1 = this.password.newPassword !== "" && this.password.oldPassword !== '' && this.password.checkPassword !== '' || this.password.newPassword === "" && this.password.oldPassword === '' && this.password.checkPassword === '';
      if (checkPasswd1 && this.password.newPassword === this.password.checkPassword && this.accountInfo.registrationCode !== '') {
        if (this.password.newPassword !== '' && this.password.oldPassword !== '' && this.password.newPassword === this.password.oldPassword) {
          this.$notify.success({
            title: '提示',
            message: '旧密码和新密码不能相同',
            position: 'bottom-right'
          })
          return
        }
        this.accountInfo.managerInfo.forEach(item => {
          if (this.accountInfo.isManager.indexOf(item) != -1) {
            item.dashboard_sales = 1;
          } else if (this.accountInfo.isManager.indexOf(item) == -1) {
            item.dashboard_sales = 2;
          }
        })

        this.accountInfo.oldPassword = this.password.oldPassword
        this.accountInfo.newPassword = this.password.newPassword

        this.accountInfo.registrationCode = this.registrationCode == this.accountInfo.registrationCode ? '' : this.accountInfo.registrationCode
        this.accountInfo.changeAuthority = this.changeAuthoritys.find(item => item.id == this.accountInfo.changeAuthority).is_admin == 1 ? '' : this.accountInfo.changeAuthority

        this.loading = true
        setAccountInfo(this.accountInfo, this.token).then(res => {
          let {data} = res
          if (data.code == 200) {
            this.centerDialogVisible = false
            if (data.date == 1) this.$router.replace({path: '/login'})
            this.$notify.success({
              title: '修改成功',
              message: data.msg,
              position: 'bottom-right'
            })
          } else {
            this.$notify.error({
              title: '修改错误',
              message: data.msg,
              position: 'bottom-right'
            })
          }
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.$notify({
          title: '警告',
          message: '请确认必填项内容填写',
          type: 'warning',
          position: 'bottom-right'
        })
      }
    },
    quxiao() {
      // this.$refs['password'].resetFields();
      this.$confirm('当前正在编辑的内容尚未保存，是否要取消修改？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '已取消修改'
        });
        this.centerDialogVisible = false
      })
    }
  },
  computed: {
    username() {
      let {xm} = JSON.parse(sessionStorage.getItem('user'))
      let {supplierShortName} = JSON.parse(sessionStorage.getItem('user'))
      return xm.toUpperCase() != null && xm.toUpperCase() != '' && supplierShortName.toUpperCase() != null && supplierShortName.toUpperCase() != '' ? supplierShortName.toUpperCase() + ' 的 ' + xm.toUpperCase() : xm.toUpperCase()
    }
  }
}
</script>

<style scoped>
.btn-tool {
  border: none;
  background: transparent;
  font-size: 18px;
  padding: 5px 10px;
  cursor: pointer;
  outline: none;
  text-align: left;
}

.user-name {
  color: whitesmoke;
  font-size: 15px;
}

.header-box {
  /*height: 64px;*/
  background-color: #EF6C00;
  padding-left: 24px;
  padding-right: 24px;
  box-sizing: inherit;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), -1px 1px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
}

.el-form >>> .el-form-item .el-form-item__label {
  white-space: pre-line;
  line-height: 16px;
  text-align: right;
  padding-right: 20px;
  margin-top: 10px;
}

.el-alert {
  padding: 0px;
  margin: 0px 0px 0px -5px;
  width: 100%;
}

.el-alert--info.is-light {
  background-color: #ffffff;
}

>>> .el-alert--info .el-alert__description {
  color: #c0c4cc;
}


</style>
<style>
.myForm .el-form-item__error {
  display: none;
}
</style>
